import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a5c9518"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "writing-board-tool" }
const _hoisted_2 = { class: "colors" }
const _hoisted_3 = ["onClick"]

import { PropType, ref, StyleValue, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { db } from '@/utils/database'
import WritingBoard from '@/components/WritingBoard.vue'

type WritingBoardModel = 'pen' | 'mark' | 'eraser'


export default /*#__PURE__*/_defineComponent({
  __name: 'WritingBoardTool',
  props: {
  slideWidth: {
    type: Number,
    required: true,
  },
  slideHeight: {
    type: Number,
    required: true,
  },
  position: {
    type: Object as PropType<StyleValue>,
    default: () => ({
      right: '5px',
      bottom: '5px',
    })
  },
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const writingBoardColors = ['#000000', '#ffffff', '#1e497b', '#4e81bb', '#e2534d', '#9aba60', '#8165a0', '#47acc5', '#f9974c', '#ffff3a']





const { currentSlide } = storeToRefs(useSlidesStore())

const writingBoardRef = ref<typeof WritingBoard>()
const writingBoardColor = ref('#e2534d')
const writingBoardModel = ref<WritingBoardModel>('pen')
const blackboard = ref(false)

const changeModel = (model: WritingBoardModel) => {
  writingBoardModel.value = model
}

// 清除画布上的墨迹
const clearCanvas = () => {
  writingBoardRef.value!.clearCanvas()
}

// 修改画笔颜色，如果当前处于橡皮状态则先切换到画笔状态
const changeColor = (color: string) => {
  if (writingBoardModel.value === 'eraser') writingBoardModel.value = 'pen'
  writingBoardColor.value = color
}

// 关闭写字板
const closeWritingBoard = () => {
  emit('close')
}

// 打开画笔工具或切换页面时，将数据库中存储的墨迹绘制到画布上
watch(currentSlide, () => {
  db.writingBoardImgs.where('id').equals(currentSlide.value.id).toArray().then(ret => {
    const currentImg = ret[0]
    writingBoardRef.value!.setImageDataURL(currentImg?.dataURL || '')
  })
}, { immediate: true })

// 每次绘制完成后将绘制完的图片更新到数据库
const hanldeWritingEnd = () => {
  const dataURL = writingBoardRef.value!.getImageDataURL()
  db.writingBoardImgs.where('id').equals(currentSlide.value.id).toArray().then(ret => {
    const currentImg = ret[0]
    if (currentImg) db.writingBoardImgs.update(currentImg, { dataURL })
    else db.writingBoardImgs.add({ id: currentSlide.value.id, dataURL })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_IconWrite = _resolveComponent("IconWrite")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_IconHighLight = _resolveComponent("IconHighLight")!
  const _component_IconErase = _resolveComponent("IconErase")!
  const _component_IconClear = _resolveComponent("IconClear")!
  const _component_IconFill = _resolveComponent("IconFill")!
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "writing-board-wrap",
      style: _normalizeStyle({
        width: __props.slideWidth + 'px',
        height: __props.slideHeight + 'px',
      })
    }, [
      _createVNode(WritingBoard, {
        ref_key: "writingBoardRef",
        ref: writingBoardRef,
        color: writingBoardColor.value,
        blackboard: blackboard.value,
        model: writingBoardModel.value,
        onEnd: _cache[0] || (_cache[0] = ($event: any) => (hanldeWritingEnd()))
      }, null, 8, ["color", "blackboard", "model"])
    ], 4),
    _createElementVNode("div", {
      class: "tools",
      style: _normalizeStyle(__props.position)
    }, [
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "画笔"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { 'active': writingBoardModel.value === 'pen' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeModel('pen')))
          }, [
            _createVNode(_component_IconWrite, { class: "icon" })
          ], 2)
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "荧光笔"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { 'active': writingBoardModel.value === 'mark' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeModel('mark')))
          }, [
            _createVNode(_component_IconHighLight, { class: "icon" })
          ], 2)
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "橡皮擦"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { 'active': writingBoardModel.value === 'eraser' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeModel('eraser')))
          }, [
            _createVNode(_component_IconErase, { class: "icon" })
          ], 2)
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "清除墨迹"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (clearCanvas()))
          }, [
            _createVNode(_component_IconClear, { class: "icon" })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "黑板"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { 'active': blackboard.value }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (blackboard.value = !blackboard.value))
          }, [
            _createVNode(_component_IconFill, { class: "icon" })
          ], 2)
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(writingBoardColors, (color) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["color", { 'active': color === writingBoardColor.value }]),
            key: color,
            style: _normalizeStyle({ backgroundColor: color }),
            onClick: ($event: any) => (changeColor(color))
          }, null, 14, _hoisted_3)
        }), 64))
      ]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.3,
        title: "关闭画笔"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (closeWritingBoard()))
          }, [
            _createVNode(_component_IconClose, { class: "icon" })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"])
    ], 4)
  ]))
}
}

})